"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var fetch = tslib_1.__importStar(require("@biw/client-fetch"));
var get_1 = tslib_1.__importDefault(require("lodash/get"));
exports.PLAN_SETS = 'planSets';
exports.PARTICIPANT_PROGRESS = 'participantProgress';
exports.SAVE_GOAL = 'saveGoal';
function postPlanProgress(paxProgress) {
    return fetch.clientFetch({
        method: 'post',
        url: '/api/v1.0/user/progress/myplan',
        type: exports.PLAN_SETS,
        body: paxProgress
    });
}
exports.postPlanProgress = postPlanProgress;
function fetchPlanData(program, userId) {
    var url = "/api/v1.0/manager/viewPlan/" + userId + "/" + program.programId;
    return fetch.clientFetch({
        url: url,
        type: exports.PARTICIPANT_PROGRESS
    }).then(function (plan) { return ({ plan: plan }); });
}
exports.fetchPlanData = fetchPlanData;
function serializePlanData(planData) {
    return {
        programId: planData.programId,
        goalQuestMyPlanVOs: get_1.default(planData, 'goalQuestMyPlanVOs', []).map(function (plan) { return ({
            id: plan.id,
            // hack around the api being weird by inserting an empty space
            obstacle: plan.obstacle || ' ',
            positive: plan.positive || ' ',
            actionSteps: (plan.actionSteps || []).map(function (plan) { return ({
                id: plan.id,
                actionStep: plan.actionStep || '',
                actionStepStatus: plan.actionStepStatus || false
            }); })
        }); })
    };
}
exports.serializePlanData = serializePlanData;
exports.getProgramViewProgressType = function (programViewId) { return "PROGRAM_VIEW_" + programViewId + "_PROGRESS"; };
function getProgramViewProgress(programViewId) {
    return fetch.clientFetch({
        url: "/api/v1.0/program-views/" + programViewId + "/progress",
        type: exports.getProgramViewProgressType(programViewId)
    });
}
exports.getProgramViewProgress = getProgramViewProgress;
exports.getProgramViewTablesType = function (programViewId) { return "PROGRAM_VIEW_" + programViewId + "_TABLES"; };
function getProgramViewTables(programViewId, orgId) {
    if (orgId === void 0) { orgId = 'Corporate'; }
    var url = orgId === 'Corporate' ?
        "/api/v1.0/program-views/" + programViewId + "/progress" :
        "/api/v1.0/program-views/" + programViewId + "/tables/" + orgId;
    return fetch.clientFetch({ url: url, type: exports.getProgramViewTablesType(programViewId) });
}
exports.getProgramViewTables = getProgramViewTables;
exports.postGoal = function (goalInfo) {
    return fetch.clientFetch({
        url: '/api/v1.0/program/goalSelection',
        method: 'post',
        body: goalInfo,
        type: exports.SAVE_GOAL
    });
};
//# sourceMappingURL=api.js.map